module.exports = ["normal","bold","bolder","lighter","100","200","300","400","500","600","700","800","900"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-font-weight-keywords/index.json
// module id = k3kT
// module chunks = 1